import { Photo } from '@capacitor/camera';

export type DocumentUploadSource =
	| { data: string; kind: 'base64'; name: string; type: string }
	| { file: File; kind: 'file' }
	| { kind: 'photo'; photo: Photo };

type DocumentUploadPhase = 'preparing' | 'processing' | 'transferring';

type DocumentUploadStatus = 'failed' | 'pending' | 'running' | 'succeeded';

export interface DocumentUploadItem {
	fileName: string;
	id: string;
	phase: DocumentUploadPhase;
	progress: number;
	status: DocumentUploadStatus;
}

export interface DocumentUploadStateInterface {
	completedCount: number;
	isProcessing: boolean;
	uploads: Map<string, DocumentUploadItem>;
}

function state(): DocumentUploadStateInterface {
	return {
		completedCount: 0,
		isProcessing: false,
		uploads: new Map<string, DocumentUploadItem>(),
	};
}

export default state;
